module.exports = __webpack_public_path__ + "media/images/div_lens/masonry-img-5-4cdbaa77571c0aa00a663f5caaef1ad0.png";